import React, { useEffect, useState } from "react"

import styles from './Snackbar.module.scss';

const Snackbar = ({message, duration = 5000, variant = "success"}) => {
    const [isVisible, setIsVisible] = useState();

    useEffect(() => {
        setIsVisible(true);
    }, [])

    useEffect(() => {
        if (isVisible) {
            const timeout = setTimeout(() => {
                setIsVisible(!isVisible);
            }, duration);

            return () => clearTimeout(timeout);
        }
    }, [isVisible, duration]);

    return (
        <div className={`${styles.snackbar} ${styles[variant]} ${isVisible ? styles.show : styles.hide}`}>
            {message}
        </div>
    )
}

export default Snackbar;